/* 7B UI fixes (push 7, Oct 29 2026). Loaded deferred by sections/7b-header.liquid on every page.
   1. Sort dropdown (collection + search): closes on option pick, outside tap and Esc; never keeps a fixed width.
   2. Quantity: max = stock. PDP reads data-b7-inv on quantity-wrapper (variant id -> stock, only for variants that
      stop selling at 0). + is disabled at the max; stock 1 hides the stepper. Cart: typing over the stock is clamped
      and the message gets its own line under the item instead of Symmetry's floating popup. */
(function () {
  var doc = document;

  /* ---------- 1. sort dropdown ---------- */
  function closeDrop(dd) {
    var b = dd && dd.querySelector('.link-dropdown__button');
    if (b && b.getAttribute('aria-expanded') === 'true') b.click();
  }
  function openDrops() { return doc.querySelectorAll('link-dropdown .link-dropdown__button[aria-expanded="true"]'); }
  doc.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.link-dropdown__link');
    if (link) {
      var dd = link.closest('link-dropdown');
      dd.querySelectorAll('.link-dropdown__link').forEach(function (a) { a.classList.toggle('link-dropdown__link--active', a === link); a.removeAttribute('aria-current'); });
      link.setAttribute('aria-current', 'true');
      setTimeout(function () { closeDrop(dd); }, 0);
    }
  }, true);
  // touch: iOS does not send clicks from plain page areas to document, so close on pointerdown outside
  doc.addEventListener('pointerdown', function (e) {
    openDrops().forEach(function (b) { var dd = b.closest('link-dropdown'); if (!dd.contains(e.target)) closeDrop(dd); });
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    openDrops().forEach(function (b) { closeDrop(b.closest('link-dropdown')); b.focus(); });
  });
  function markSort() {
    doc.querySelectorAll('.link-dropdown__link--active').forEach(function (a) { a.setAttribute('aria-current', 'true'); });
  }

  /* ---------- 2. quantity = stock ---------- */
  function qtyFor(wrap) {
    var inv; try { inv = JSON.parse(wrap.dataset.b7Inv || '{}'); } catch (e) { inv = {}; }
    var form = wrap.closest('form');
    var idEl = form && form.querySelector('[name="id"]');
    var max = idEl ? inv[idEl.value] : undefined;
    var input = wrap.querySelector('input');
    var up = wrap.querySelector('[data-quantity="up"]');
    if (!input) return;
    if (max > 0) input.max = max; else input.removeAttribute('max');
    if (max > 0 && +input.value > max) input.value = max;
    var atMax = max > 0 && +input.value >= max;
    if (up) { up.classList.toggle('b7q-off', atMax); up.setAttribute('aria-disabled', String(atMax)); }
    var row = wrap.closest('.quantity-submit-row');
    wrap.classList.toggle('b7q-one', max === 1);
    if (row) row.classList.toggle('b7q-single', max === 1);
  }
  function allQty() { doc.querySelectorAll('quantity-wrapper[data-b7-inv]').forEach(qtyFor); }
  doc.addEventListener('click', function (e) {
    var up = e.target.closest && e.target.closest('quantity-wrapper [data-quantity="up"].b7q-off');
    if (up) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  doc.addEventListener('change', function (e) {
    var w = e.target.closest && e.target.closest('quantity-wrapper[data-b7-inv]');
    if (w) qtyFor(w);
  });
  doc.addEventListener('on:variant:change', function () { setTimeout(allQty, 0); });

  // cart page + drawer: clamp to stock before Symmetry's handler, show the note on its own line
  function cartClamp(e) {
    var i = e.target;
    if (!i.classList || !i.classList.contains('cart-item__quantity-input') || !i.max) return;
    var col = i.closest('.cart-item__quantity');
    var note = col && col.parentElement.querySelector('.b7q-note');
    if (+i.value > +i.max) {
      i.value = i.max;
      if (col && !note) {
        note = doc.createElement('p');
        note.className = 'b7q-note';
        note.setAttribute('role', 'status');
        col.insertAdjacentElement('afterend', note);
      }
      var s = window.theme && theme.strings && theme.strings.cartItemsQuantityError;
      if (note) note.textContent = (s || 'You can only add [QUANTITY] of this item to your cart.').replace('[QUANTITY]', i.max);
    } else if (note) note.remove();
  }
  doc.addEventListener('change', cartClamp, true);
  doc.addEventListener('input', cartClamp, true);

  /* ---------- 3. narrow cards (push 10): image on top, text below when the text column gets too narrow ----------
     [card, text part, smallest text width]. The width a card needs is measured while it is side by side
     (card width - text width + minimum), so it works for any image size or button next to the text. */
  var STACK = [['.b7ps-prod', '.b7ps-prod__txt', 120], ['.b7ps-coll', '.b7ps-coll__txt', 100], ['.b7cs__item', '.b7cs__info', 110],
    ['.cart-item', '.cart-item__description', 140], ['.b7qa', '.b7qa__head', 240], ['.b7j__card--feat', '.b7j__body', 260]];
  /* label + arrow: the label wraps only between words; a word that still does not fit shrinks the text (to 10px) */
  var FIT = '.b7-tile__name,.b7-cta__in,.b7-band__t,.b7lt__link,.b7lt__h,.navigation__link,.b7ps-coll__t';
  var ro = window.ResizeObserver && new ResizeObserver(function (es) { es.forEach(function (e) { size(e.target); }); });
  function size(el) {
    if (el.b7fit) return fit(el);
    var c = el.b7cfg, t = el.querySelector(c[1]);
    if (!t || !el.offsetWidth) return;
    if (!el.classList.contains('b7-stack')) el.b7need = el.offsetWidth - t.offsetWidth + c[2];
    el.classList.toggle('b7-stack', el.offsetWidth < el.b7need);
    // push 11: a stacked card shows a much bigger image; give srcset its real width (x DPR picks a sharp file)
    el.querySelectorAll('img[srcset]').forEach(function (i) { var w = Math.ceil(i.getBoundingClientRect().width); if (w > 0 && i.b7w !== w) { i.b7w = w; i.sizes = w + 'px'; } });
  }
  function fit(el) {
    el.style.fontSize = '';
    var fs = parseFloat(getComputedStyle(el).fontSize);
    while (fs > 10 && el.scrollWidth > el.clientWidth + 1) { fs -= 1; el.style.fontSize = fs + 'px'; }
  }
  function watch(root) {
    if (!ro) return;
    STACK.forEach(function (c) { root.querySelectorAll(c[0]).forEach(function (el) { if (!el.b7cfg) { el.b7cfg = c; ro.observe(el); } }); });
    root.querySelectorAll(FIT).forEach(function (el) { if (!el.b7fit) { el.b7fit = 1; ro.observe(el); } });
  }
  /* hotfix 2: every iframe needs a title (screen readers): YouTube/Vimeo, maps, app widgets */
  function frameTitles() {
    doc.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(function (f) {
      var s = f.src || '';
      f.title = f.getAttribute('aria-label') || (/youtu|vimeo/.test(s) ? 'Video' : /maps/.test(s) ? 'Map' : 'Embedded content');
    });
  }

  /* ---------- 4. landing "See all N products" (push 10): smooth scroll so the grid's Filter | Sort bar lands
     right under the sticky header (measured: the header-group sections that stick, at their stuck position) ---------- */
  // live = where the sticky header-group sections are now (Symmetry hides the header while scrolling down on phones)
  function stickyH(live) {
    var h = 0;
    doc.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) {
      var cs = getComputedStyle(s);
      if ((cs.position !== 'sticky' && cs.position !== 'fixed') || !s.offsetHeight) return;
      var stuck = (parseFloat(cs.top) || 0) + s.offsetHeight;
      h = Math.max(h, live ? Math.min(stuck, s.getBoundingClientRect().bottom) : stuck);
    });
    return Math.max(0, h);
  }
  function gridTop() {
    var anchor = doc.getElementById('b7-grid'), all = doc.querySelectorAll('.utility-bar:not(.utility-bar--sticky-mobile-copy)');
    for (var i = 0; i < all.length; i++) if (anchor.compareDocumentPosition(all[i]) & 4) return all[i];
    return anchor;
  }
  doc.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#b7-grid"]');
    if (!a || !doc.getElementById('b7-grid')) return;
    e.preventDefault();
    history.replaceState(null, '', '#b7-grid');
    var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches, n = 0;
    scrollTo({ top: Math.max(0, gridTop().getBoundingClientRect().top + scrollY - stickyH()), behavior: smooth ? 'smooth' : 'auto' });
    // images above load while scrolling and push the grid down: re-measure until it sits under the header
    (function fix() {
      setTimeout(function () {
        var off = gridTop().getBoundingClientRect().top - stickyH(true);
        if (Math.abs(off) > 3 && n++ < 4) { scrollBy({ top: off, behavior: smooth && n < 2 ? 'smooth' : 'auto' }); fix(); }
      }, n ? 450 : 900);
    })();
  });

  /* ---------- 5. value strip on phones (push 10): slow auto-scroll, one item every 4s; stops for good on touch ---------- */
  function vpAuto() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    doc.querySelectorAll('[data-b7-vp][data-auto]').forEach(function (vp) {
      var stop = false;
      vp.addEventListener('pointerdown', function () { stop = true; }, { passive: true });
      setInterval(function () {
        if (stop || vp.scrollWidth <= vp.clientWidth + 2) return;
        var end = vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 2;
        vp.scrollTo({ left: end ? 0 : vp.scrollLeft + vp.clientWidth / 2, behavior: 'smooth' });
      }, 4000);
    });
  }

  function start() { markSort(); allQty(); watch(doc); vpAuto(); frameTitles(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  // ajax collection/search reloads + cart refreshes replace markup
  doc.addEventListener('on:cart:change', function () { setTimeout(allQty, 300); });
  // whole body: cart drawer, search panel and quick add are outside main
  var mt;
  new MutationObserver(function (m) { for (var k = 0; k < m.length; k++) if (m[k].addedNodes.length) { clearTimeout(mt); mt = setTimeout(function () { markSort(); watch(doc); frameTitles(); }, 60); break; } })
    .observe(doc.body, { childList: true, subtree: true });
})();
